<template>
    <div class="netflix-banner">
    <div class="main-image">
        <div class="main-video">
        <video poster="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fidentity-mag.com%2Fwp-content%2Fuploads%2F2020%2F09%2Fmulan-2020.png&f=1&nofb=1" 
        src="../assets/Disneys-Mulan-Official-Trailer.mp4" autoplay playsinline style="opacity: 1;"></video>
          </div>
        </div>
   
   <div class="info">
       <div class="mulanlogo">
           <img src="../assets/mulanlogo.png"  alt="mulanlogo">
       </div>
        <div class="descript">
           <p>Mulan is a 2020 American fantasy action <br>drama film produced by Walt Disney Pictures.</p>
        </div>
        <div class="buttons">
            <a href="#" class="play"><img src="../assets/play-solid.svg" alt="playicon" v-on:click="play()">Play</a>
            <a href="#" class="moreinfo"><img src="../assets/info-circle-solid.svg" alt="moreinfologo">More info</a>
        </div>
   </div>
   <div class="sound">
    <div class="sound-container">
        <img src="../assets/volume-up-solid.svg" v-show="speakeronicon" v-on:click="speakeron" alt="playicon" style="height:20px;width:20px">
        <img src="../assets/volume-mute-solid.svg" v-show="speakerofficon" v-on:click="speakeroff" alt="playicon" style="height:20px;width:20px">
    </div>
 </div>
</div>
</template>


<script>
export default {
    data(){
       return{
                speakeronicon:true,
                speakerofficon:false
           }
    },
    methods:{
           speakeron(){
           var video = document.querySelector(".main-video video");
           this.speakeronicon = !this.speakeronicon;
           this.speakerofficon = !this.speakerofficon;
           video.volume = 0;
                },
                speakeroff(){
                    var video = document.querySelector(".main-video video");
                    this.speakeronicon = !this.speakeronicon;
                    this.speakerofficon = !this.speakerofficon;
                    video.volume = 1.0;
                },
                play(){
                    var video = document.querySelector(".main-video video");
                    video.play();
                    
                }
        }
}
</script>

<style scoped>
.netflix-banner{
    width: 100%;
    height: 100vh;
    overflow: hidden;
}
.main-image{
    width:100%;
    height:100vh;
     overflow: hidden;
}
    .main-video{
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    }
 .main-image video{
     position: absolute;
     min-width:100%;
         min-height: 100%;
    top: 43%;
    left: 50%;
    transform: translate(-50%,-50%);
 }
.main-image img{
    width:100%;
    height:100%;
    object-fit: cover;
    object-position: center;
}
 .info {
        position: absolute;
        top: 60%;
        left: 10%;
        transform: translate(-10%, -60%);
    }
    .play{
        color: black;
        background: white;
        padding: 1vw 2vw;
        border-radius: 0.3vw;
        font-weight: 600;
        transition: 0.4s all linear;
        text-decoration: none;
        font-size: 1vw;
    }
      .play:hover{
          background-color: rgba(255,255,255,0.75);
      }    
    .moreinfo{
        background-color: rgba(109,109,110,0.7);
        color: white;
        padding: 1vw 2vw;
        border-radius: 0.3vw;
        margin-left: 2vw;
        text-decoration: none;
        font-size: 1vw;
    }
    .moreinfo:hover{
        background-color: rgba(109,109,110,0.4);
    }
    .descript{
        color: white;
        margin-bottom: 3vw;
    }
    .descript p{
        font-size: 1.3vw;
    }
     .mulanlogo{
      height:150px;
      width:250px;
      overflow: hidden;
      visibility: visible;
      transition: 2s all linear;
  }
  .mulanlogo img{
      height: 100%;
      width:100%;
      object-fit: cover;
      object-position: center;
  }
  .hidemulanlogo{
     visibility: hidden;
  }
  .play img, .moreinfo img{
      height:15px;
      width:15px;
      
      transform: translateY(2px);
      margin-right: 10px;
  }
  .sound{
      position: absolute;
    top: 70%;
    right: 10%;
    border: 0.1vw solid white;
    border-radius: 50%;
    padding: 0.7vw;
    height: 1.2vw;
    width: 1.2vw;
  }
  .sound-container{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
</style>